import React from "react";
import { Box, Typography } from "@mui/material";
import ReleaseNoteItem from "./ReleaseNoteItem";
import styles from "./ChangeLog.module.css";
import { Routes } from "../../routes/routes";
import { Link } from "react-router-dom";

interface Props {
  handleLinkClick: (link: string) => void;
}

const ReleaseNotes: React.FC<Props> = ({ handleLinkClick }) => {
  return (
    <Box>
      <Typography className={styles.descriptionText}>
        For detailed release notes of each component, see below:
      </Typography>
      <ul style={{ paddingLeft: "20px" }}>
        <ReleaseNoteItem
          title="Garuda2x"
          link="https://sbxcorp.atlassian.net/wiki/external/ZjExOTgyYzRiMjQ1NGYxYWFmNmFkODNiYjc5NjYzNmI"
          description="Release Notes: Garuda2x Store (Garuda2X 2.5.26)"
          handleLinkClick={handleLinkClick}
        />

        {/* <ReleaseNoteItem
                title="GadgetBuilder (Offline)"
                link="https://sbxcorp.atlassian.net/wiki/external/NDk3MmRlYWQzYjVkNDYxYmE3MzUyNGEzMTIyNDgwM2M"
                description="Offline Agent Builder Release Notes (Garuda2X 2.5.22)"
                handleLinkClick={handleLinkClick}
            />
            <ReleaseNoteItem
                title="GadgetBuilder (Web)"
                link="https://sbxcorp.atlassian.net/wiki/external/NjdkMDZhZDU0NTE4NDM0MGFiNGJiMGM4ZmU4NmQxZTQ"
                description="Online Agent Builder Release Notes (Garuda2X 2.5.22)"
                handleLinkClick={handleLinkClick}
            />
            <ReleaseNoteItem
                title="AdminPortal (Web)"
                link="https://sbxcorp.atlassian.net/wiki/external/MDIyNmMzZjI1ZDdmNGZhZWE4OTRiMTQ2ODM4YjgxZjA"
                description="Admin Portal Release Notes (Garuda2X 2.5.22)"
                handleLinkClick={handleLinkClick}
            />
            <ReleaseNoteItem
                title="GroupAdminPortal (Web)"
                link="https://sbxcorp.atlassian.net/wiki/external/NWRlNzNmZGZlM2U1NDljNGE1YzgwZWY3OWFhYjBkY2U"
                description="Group Admin Portal Release Notes (Garuda2X 2.5.22)"
                handleLinkClick={handleLinkClick}
            />
            <ReleaseNoteItem
                title="Recipe Player/Builder (Online)"
                link="https://sbxcorp.atlassian.net/wiki/external/NDkwM2UwMzcyZDBmNGI0YzljY2E5NWMxZWM2ZDVjYjk"
                description="Recipe Player (Online) Release Notes (Garuda2X 2.5.22)"
                handleLinkClick={handleLinkClick}
            />
            <ReleaseNoteItem
                title="Recipe Player/Builder (Offline)"
                link="https://sbxcorp.atlassian.net/wiki/external/NThhODg3ZDE2MWRmNDMyNmEzZDdmZDBkYzJiMTEyNzE"
                description="Recipe Player (Offline) Release Notes (Garuda2X 2.5.22)"
                handleLinkClick={handleLinkClick}
            /> */}
      </ul>
      <Box>
        <Typography variant="subtitle1" fontWeight={600}>
          {" "}
          Try Garuda 2x Now!{" "}
        </Typography>
        <Typography variant="subtitle1">
          {" "}
          You can <Link to={"/"+Routes.DOWNLOADS} style={{color: "#44bcdb"}}>download</Link> the trial
          version of Garuda 2x today and discover the possibilities.
        </Typography>
      </Box>
    </Box>
  );
};

export default ReleaseNotes;
